import CommonAction from '../../shared/Http/Http';
import {ADMINS_GET,PERMISION_UPDATE,CREATE_ADMIN,RESET_ADMIN_PASSWORD} from '../constants';

export const adminsGet = body => CommonAction('POST', null, `backoffice/admins`, ADMINS_GET, body);
export const adminsUpdate = (id, body) => CommonAction('PUT', null, `backoffice/admin/update/${id}`, PERMISION_UPDATE, body);
export const createAdmin = body => CommonAction('POST', null, `backoffice/admin/create`,CREATE_ADMIN, body);
export const resetPassword = body => CommonAction('POST', null, `backoffice/admin/reset-password`,RESET_ADMIN_PASSWORD, body);

 